import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { Button, RecordsTable, Tooltip, WidgetShell, } from "@eudonet/opal";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { buildContactAddressColumns } from "./contactAddressTable";
import ContactEditAddressFormModal from "./ContactEditAddressFormModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactAddressesWidget',
    props: {
        addresses: {},
        contactId: {},
        canEdit: { type: Boolean }
    },
    emits: ["expand", "add", "updated", "delete", "update:primary"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const showEditModal = ref(false);
        const editTarget = ref(null);
        const onEdit = (address) => {
            editTarget.value = address;
            showEditModal.value = true;
        };
        const onDeleteFromModal = () => {
            if (editTarget.value)
                emit("delete", editTarget.value);
            showEditModal.value = false;
        };
        const primaryId = computed(() => props.addresses.find((a) => a.isPrimary)?.id ?? "");
        const columns = computed(() => buildContactAddressColumns({
            t,
            primaryId: primaryId.value,
            onSetPrimary: (target) => emit("update:primary", target),
            radioPrefix: "primary",
            canEdit: props.canEdit,
            onEdit: props.canEdit ? onEdit : undefined,
            onDelete: props.canEdit ? (address) => emit("delete", address) : undefined,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(WidgetShell), {
                    header: _ctx.$t('contact.detail.addresses.title')
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_unref(Tooltip), {
                            text: _unref(t)('common.permissions.noEditRights'),
                            disabled: props.canEdit,
                            tabindex: props.canEdit ? undefined : 0
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Button), {
                                    variant: "primary",
                                    size: "sm",
                                    "icon-left": "ri-add-line",
                                    label: _ctx.$t('contact.detail.addresses.addAddress'),
                                    disabled: !props.canEdit,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('add')))
                                }, null, 8 /* PROPS */, ["label", "disabled"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["text", "disabled", "tabindex"]),
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            "icon-only": "",
                            "icon-left": "ri-expand-diagonal-fill",
                            "aria-label": _ctx.$t('contact.detail.addresses.expand'),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('expand')))
                        }, null, 8 /* PROPS */, ["aria-label"])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_unref(RecordsTable), {
                            columns: columns.value,
                            data: __props.addresses,
                            "table-class": 'min-w-130',
                            "empty-text": _ctx.$t('contact.detail.addresses.empty')
                        }, null, 8 /* PROPS */, ["columns", "data", "empty-text"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["header"]),
                (editTarget.value)
                    ? (_openBlock(), _createBlock(ContactEditAddressFormModal, {
                        key: 0,
                        modelValue: showEditModal.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showEditModal).value = $event)),
                        "contact-id": __props.contactId,
                        "initial-address": editTarget.value,
                        onUpdated: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('updated'))),
                        onDelete: onDeleteFromModal
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "initial-address"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
